import React from 'react';
import { IApiSessionMsgFeedbackReq } from '@/services/swagger/easourcing/models';
import { feedbackPost } from '@/services/swagger/easourcing/SessionService';
import { useChatPageStore } from '../../store';
import { useLockFn } from 'ahooks';
import { SvgBtnBox } from '@/common/base/SvgBtnBox';
import DislikeIcon from '@/assets/icons/dislike.svg?react';
import LikeSelectedIcon from '@/assets/icons/like-selected.svg?react';
import DislikeSelectedIcon from '@/assets/icons/dislike-selected.svg?react';
import LikeIcon from '@/assets/icons/like.svg?react';
import mixpanel from 'mixpanel-browser';
import cn from 'classnames';
import { FeedbackDialogV2 } from '../base/feedback-form-dialog';

interface MessageFeedbackProps {
  like?: number;
  sessionId: string;
  messageId: string;
  className?: string;
}

export const MessageFeedback: React.FC<MessageFeedbackProps> = ({ like, sessionId, messageId, className }) => {
  const [isFeedbackDialogOpen, setIsFeedbackDialogOpen] = React.useState(false);
  const [feedBtnLoading, setFeedBtnLoading] = React.useState(false);
  const updateMsgItem = useChatPageStore(store => store.updateMsgItem);

  const handleFeedbackClick = (type: IApiSessionMsgFeedbackReq['type']) => {
    const currentValue = like ?? 0;
    const newValue = like === type ? 0 : type;
    updateMsgItem(messageId, prev => ({
      ...prev,
      like: newValue ?? 0,
    }));
    feedbackPost({
      sessionId,
      messageId,
      type: like === type ? 0 : type,
    }).catch(() => {
      updateMsgItem(messageId, prev => ({
        ...prev,
        like: currentValue,
      }));
    });
  };

  const onFeedbackDialogSubmit = useLockFn(async (feedbackList: string[], feedbackContent: string) => {
    setFeedBtnLoading(true);
    await feedbackPost({
      sessionId,
      messageId,
      type: 3,
      specifiedFeedback: feedbackList,
      feedback: feedbackContent,
    }).catch(err => {
      setFeedBtnLoading(false);
      throw err;
    });
    setFeedBtnLoading(false);
    setIsFeedbackDialogOpen(false);
  });
  const handleSubmit = async (data: { selectedTags: string[]; content: string }) => {
    await onFeedbackDialogSubmit(data.selectedTags, data.content);
  };

  return (
    <div className={cn('mt-2', className)}>
      <div className="flex items-center gap-1">
        <SvgBtnBox
          className="size-6"
          onClick={() => {
            mixpanel.track('result_thumbs_up_click');
            handleFeedbackClick(1);
            setIsFeedbackDialogOpen(false);
          }}
        >
          {like === 1 ? <LikeSelectedIcon /> : <LikeIcon />}
        </SvgBtnBox>
        <SvgBtnBox
          className="size-6"
          onClick={() => {
            mixpanel.track('result_thumbs_down_click');
            if (like !== 2) {
              setIsFeedbackDialogOpen(true);
            } else {
              setIsFeedbackDialogOpen(false);
            }
            handleFeedbackClick(2);
          }}
        >
          {like === 2 ? <DislikeSelectedIcon /> : <DislikeIcon />}
        </SvgBtnBox>
      </div>
      <FeedbackDialogV2
        loading={feedBtnLoading}
        open={isFeedbackDialogOpen}
        onClose={() => setIsFeedbackDialogOpen(false)}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
